var map = {
	"./AGoodNewsStoryFromPeddie": [
		360,
		59
	],
	"./AGoodNewsStoryFromPeddie.js": [
		360,
		59
	],
	"./AdviceFromTheExpertsPart10": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart10.js": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart11": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart11.js": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart5": [
		281,
		50
	],
	"./AdviceFromTheExpertsPart5.js": [
		281,
		50
	],
	"./AdviceFromTheExpertsPart6": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart6.js": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart7": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart7.js": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart8": [
		372,
		64
	],
	"./AdviceFromTheExpertsPart8.js": [
		372,
		64
	],
	"./AdviceFromTheExpertsPart9": [
		373,
		65
	],
	"./AdviceFromTheExpertsPart9.js": [
		373,
		65
	],
	"./AdviceFromTheExpertsTenantsPart1": [
		282,
		51
	],
	"./AdviceFromTheExpertsTenantsPart1.js": [
		282,
		51
	],
	"./AdviceFromTheExpertsTenantsPart2": [
		283,
		52
	],
	"./AdviceFromTheExpertsTenantsPart2.js": [
		283,
		52
	],
	"./AlternativeEnergyInstallations": [
		362,
		66
	],
	"./AlternativeEnergyInstallations.js": [
		362,
		66
	],
	"./ApplyingSASRIAExtensions": [
		374,
		67
	],
	"./ApplyingSASRIAExtensions.js": [
		374,
		67
	],
	"./AreGardensOwnedByUnitOwners": [
		284,
		68
	],
	"./AreGardensOwnedByUnitOwners.js": [
		284,
		68
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair": [
		285,
		69
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair.js": [
		285,
		69
	],
	"./CIAGeyserEmergencyAssist": [
		363,
		70
	],
	"./CIAGeyserEmergencyAssist.js": [
		363,
		70
	],
	"./CIAPrivacyPolicy": [
		375,
		15
	],
	"./CIAPrivacyPolicy.js": [
		375,
		15
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers": [
		286,
		71
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers.js": [
		286,
		71
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2": [
		287,
		72
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2.js": [
		287,
		72
	],
	"./CiaIssuesPolicy": [
		288,
		53
	],
	"./CiaIssuesPolicy.js": [
		288,
		53
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining": [
		376,
		73
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining.js": [
		376,
		73
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount": [
		289,
		54
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount.js": [
		289,
		54
	],
	"./CommonPropertyPart1": [
		377,
		74
	],
	"./CommonPropertyPart1.js": [
		377,
		74
	],
	"./CommonPropertyPart2": [
		378,
		75
	],
	"./CommonPropertyPart2.js": [
		378,
		75
	],
	"./CommonPropertyPart3": [
		379,
		76
	],
	"./CommonPropertyPart3.js": [
		379,
		76
	],
	"./CommonPropertyPart4": [
		380,
		77
	],
	"./CommonPropertyPart4.js": [
		380,
		77
	],
	"./CommonPropertyPart5": [
		381,
		78
	],
	"./CommonPropertyPart5.js": [
		381,
		78
	],
	"./CommunitySchemesTraining": [
		382,
		79
	],
	"./CommunitySchemesTraining.js": [
		382,
		79
	],
	"./ComputeCrimeClaimsPart2": [
		290,
		80
	],
	"./ComputeCrimeClaimsPart2.js": [
		290,
		80
	],
	"./ComputeCrimeClaimsPart3": [
		291,
		81
	],
	"./ComputeCrimeClaimsPart3.js": [
		291,
		81
	],
	"./ComputerCrimePolicyWordingChanges": [
		292,
		82
	],
	"./ComputerCrimePolicyWordingChanges.js": [
		292,
		82
	],
	"./ComputerCrimePolicyWordingChanges1": [
		383,
		83
	],
	"./ComputerCrimePolicyWordingChanges1.js": [
		383,
		83
	],
	"./ComputerCrimeWordingProposalFormPart1": [
		293,
		84
	],
	"./ComputerCrimeWordingProposalFormPart1.js": [
		293,
		84
	],
	"./DealingWithABodyCorporateClaim": [
		294,
		85
	],
	"./DealingWithABodyCorporateClaim.js": [
		294,
		85
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection": [
		295,
		86
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection.js": [
		295,
		86
	],
	"./DidYouKnowPart1": [
		384,
		87
	],
	"./DidYouKnowPart1.js": [
		384,
		87
	],
	"./DidYouKnowPart2": [
		296,
		55
	],
	"./DidYouKnowPart2.js": [
		296,
		55
	],
	"./DidYouKnowPart3": [
		297,
		56
	],
	"./DidYouKnowPart3.js": [
		297,
		56
	],
	"./DidYouKnowPart4": [
		385,
		6
	],
	"./DidYouKnowPart4.js": [
		385,
		6
	],
	"./DidYouKnowPart5": [
		386,
		7
	],
	"./DidYouKnowPart5.js": [
		386,
		7
	],
	"./DidYouKnowPart6": [
		387,
		8
	],
	"./DidYouKnowPart6.js": [
		387,
		8
	],
	"./EmployersLiability": [
		298,
		88
	],
	"./EmployersLiability.js": [
		298,
		88
	],
	"./EnforcementOfRulesPart1": [
		388,
		16
	],
	"./EnforcementOfRulesPart1.js": [
		388,
		16
	],
	"./EnforcementOfRulesPart2": [
		389,
		17
	],
	"./EnforcementOfRulesPart2.js": [
		389,
		17
	],
	"./EnforcementOfRulesPart4": [
		390,
		18
	],
	"./EnforcementOfRulesPart4.js": [
		390,
		18
	],
	"./EnforecmentOfRulesPart3": [
		391,
		19
	],
	"./EnforecmentOfRulesPart3.js": [
		391,
		19
	],
	"./EnvironmentalUpgradeForGeysers": [
		299,
		89
	],
	"./EnvironmentalUpgradeForGeysers.js": [
		299,
		89
	],
	"./ExamplesOfCxtraCoverFollowingDamage": [
		300,
		90
	],
	"./ExamplesOfCxtraCoverFollowingDamage.js": [
		300,
		90
	],
	"./FidelityAndComputerCrimePart1": [
		392,
		91
	],
	"./FidelityAndComputerCrimePart1.js": [
		392,
		91
	],
	"./FidelityFundCertificatesAndCreditChecks": [
		301,
		92
	],
	"./FidelityFundCertificatesAndCreditChecks.js": [
		301,
		92
	],
	"./FireRiskManagementTipsProtectionAgainstFire": [
		302,
		93
	],
	"./FireRiskManagementTipsProtectionAgainstFire.js": [
		302,
		93
	],
	"./FireWisePart1": [
		393,
		94
	],
	"./FireWisePart1.js": [
		393,
		94
	],
	"./FireWisePart10": [
		394,
		95
	],
	"./FireWisePart10.js": [
		394,
		95
	],
	"./FireWisePart11": [
		395,
		96
	],
	"./FireWisePart11.js": [
		395,
		96
	],
	"./FireWisePart12": [
		364,
		97
	],
	"./FireWisePart12.js": [
		364,
		97
	],
	"./FireWisePart13": [
		303,
		98
	],
	"./FireWisePart13.js": [
		303,
		98
	],
	"./FireWisePart14": [
		304,
		99
	],
	"./FireWisePart14.js": [
		304,
		99
	],
	"./FireWisePart15": [
		305,
		0,
		139
	],
	"./FireWisePart15.js": [
		305,
		0,
		139
	],
	"./FireWisePart16": [
		306,
		100
	],
	"./FireWisePart16.js": [
		306,
		100
	],
	"./FireWisePart17": [
		307,
		101
	],
	"./FireWisePart17.js": [
		307,
		101
	],
	"./FireWisePart18": [
		308,
		102
	],
	"./FireWisePart18.js": [
		308,
		102
	],
	"./FireWisePart19": [
		309,
		103
	],
	"./FireWisePart19.js": [
		309,
		103
	],
	"./FireWisePart2": [
		310,
		0,
		137
	],
	"./FireWisePart2.js": [
		310,
		0,
		137
	],
	"./FireWisePart3": [
		311,
		0,
		138
	],
	"./FireWisePart3.js": [
		311,
		0,
		138
	],
	"./FireWisePart4": [
		365,
		104
	],
	"./FireWisePart4.js": [
		365,
		104
	],
	"./FireWisePart6": [
		396,
		105
	],
	"./FireWisePart6.js": [
		396,
		105
	],
	"./FireWisePart7": [
		397,
		106
	],
	"./FireWisePart7.js": [
		397,
		106
	],
	"./FireWisePart8": [
		398,
		107
	],
	"./FireWisePart8.js": [
		398,
		107
	],
	"./FireWisePart9": [
		399,
		108
	],
	"./FireWisePart9.js": [
		399,
		108
	],
	"./FloodRiskManagementTips": [
		312,
		109
	],
	"./FloodRiskManagementTips.js": [
		312,
		109
	],
	"./GeneralConditionsAndProvisions": [
		313,
		110
	],
	"./GeneralConditionsAndProvisions.js": [
		313,
		110
	],
	"./GeneratorPart2": [
		314,
		2
	],
	"./GeneratorPart2.js": [
		314,
		2
	],
	"./GeneratorPart3": [
		315,
		3
	],
	"./GeneratorPart3.js": [
		315,
		3
	],
	"./GeneratorPart4": [
		400,
		20
	],
	"./GeneratorPart4.js": [
		400,
		20
	],
	"./Generators": [
		401,
		21
	],
	"./Generators.js": [
		401,
		21
	],
	"./GeneratorsAndSolarSystems": [
		402,
		111
	],
	"./GeneratorsAndSolarSystems.js": [
		402,
		111
	],
	"./GuidelinesToProtectingYourVacantProperty": [
		316,
		112
	],
	"./GuidelinesToProtectingYourVacantProperty.js": [
		316,
		112
	],
	"./HeavyRainAndFlooding": [
		403,
		9
	],
	"./HeavyRainAndFlooding.js": [
		403,
		9
	],
	"./KZNFlooding": [
		404,
		22
	],
	"./KZNFlooding.js": [
		404,
		22
	],
	"./KeyInformationDocuments": [
		317,
		113
	],
	"./KeyInformationDocuments.js": [
		317,
		113
	],
	"./LayoutOfCiaWording": [
		318,
		114
	],
	"./LayoutOfCiaWording.js": [
		318,
		114
	],
	"./LegislativeRequirementsForCommunitySchemesPart1": [
		319,
		115
	],
	"./LegislativeRequirementsForCommunitySchemesPart1.js": [
		319,
		115
	],
	"./LegislativeRequirementsForCommunitySchemesPart2": [
		320,
		116
	],
	"./LegislativeRequirementsForCommunitySchemesPart2.js": [
		320,
		116
	],
	"./LetsPlayActivityBook": [
		321,
		117
	],
	"./LetsPlayActivityBook.js": [
		321,
		117
	],
	"./LiabilityClaimsMadeVsLossesOccurring": [
		322,
		118
	],
	"./LiabilityClaimsMadeVsLossesOccurring.js": [
		322,
		118
	],
	"./LithiumBatteryFiresPart2": [
		323,
		119
	],
	"./LithiumBatteryFiresPart2.js": [
		323,
		119
	],
	"./LithiumBetteryFires": [
		366,
		120
	],
	"./LithiumBetteryFires.js": [
		366,
		120
	],
	"./LoavesForMandelaDayUpdate": [
		405,
		121
	],
	"./LoavesForMandelaDayUpdate.js": [
		405,
		121
	],
	"./MachineryBreakdown": [
		324,
		122
	],
	"./MachineryBreakdown.js": [
		324,
		122
	],
	"./MessageFromSasriasManagingDirector": [
		325,
		4
	],
	"./MessageFromSasriasManagingDirector.js": [
		325,
		4
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy": [
		326,
		123
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy.js": [
		326,
		123
	],
	"./NewCpdApprovedTraining": [
		327,
		124
	],
	"./NewCpdApprovedTraining.js": [
		327,
		124
	],
	"./NewsletterSubscriberPOPIACompliance": [
		328,
		23
	],
	"./NewsletterSubscriberPOPIACompliance.js": [
		328,
		23
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers": [
		329,
		125
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers.js": [
		329,
		125
	],
	"./OvercrowdingPart1": [
		406,
		24
	],
	"./OvercrowdingPart1.js": [
		406,
		24
	],
	"./OvercrowdingPart2": [
		407,
		25
	],
	"./OvercrowdingPart2.js": [
		407,
		25
	],
	"./PersonalAccident": [
		330,
		126
	],
	"./PersonalAccident.js": [
		330,
		126
	],
	"./ProtectingVacantPropertyPart1": [
		331,
		127
	],
	"./ProtectingVacantPropertyPart1.js": [
		331,
		127
	],
	"./ProtectingVacantPropertyPart3": [
		332,
		128
	],
	"./ProtectingVacantPropertyPart3.js": [
		332,
		128
	],
	"./ProtectingVacantPropertyPart4": [
		333,
		129
	],
	"./ProtectingVacantPropertyPart4.js": [
		333,
		129
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance": [
		334,
		130
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance.js": [
		334,
		130
	],
	"./RisingDamp": [
		335,
		57
	],
	"./RisingDamp.js": [
		335,
		57
	],
	"./RisingDampPart2": [
		336,
		58
	],
	"./RisingDampPart2.js": [
		336,
		58
	],
	"./SadNewsFromCIA": [
		408,
		26
	],
	"./SadNewsFromCIA.js": [
		408,
		26
	],
	"./SasriaClaims": [
		409,
		27
	],
	"./SasriaClaims.js": [
		409,
		27
	],
	"./SasriaRateIncrease1January2022": [
		337,
		5
	],
	"./SasriaRateIncrease1January2022.js": [
		337,
		5
	],
	"./SasriaRateIncrease2025": [
		410,
		1
	],
	"./SasriaRateIncrease2025.js": [
		410,
		1
	],
	"./SasriaWrapCoverAndWordingChanges": [
		361,
		131
	],
	"./SasriaWrapCoverAndWordingChanges.js": [
		361,
		131
	],
	"./The10YearPlanPart1": [
		411,
		28
	],
	"./The10YearPlanPart1.js": [
		411,
		28
	],
	"./The10YearPlanPart2": [
		338,
		29
	],
	"./The10YearPlanPart2.js": [
		338,
		29
	],
	"./The10YearPlanPart3": [
		367,
		30
	],
	"./The10YearPlanPart3.js": [
		367,
		30
	],
	"./The10YearPlanPart4": [
		412,
		31
	],
	"./The10YearPlanPart4.js": [
		412,
		31
	],
	"./TheDevastationOfLithium": [
		359,
		132
	],
	"./TheDevastationOfLithium.js": [
		359,
		132
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies": [
		339,
		133
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies.js": [
		339,
		133
	],
	"./TheftAndCrimeRiskManagement": [
		340,
		134
	],
	"./TheftAndCrimeRiskManagement.js": [
		340,
		134
	],
	"./TrusteesIndemnity": [
		341,
		32
	],
	"./TrusteesIndemnity.js": [
		341,
		32
	],
	"./UnderstandingLiabilityClaimsPart1": [
		413,
		10
	],
	"./UnderstandingLiabilityClaimsPart1.js": [
		413,
		10
	],
	"./UnderstandingLiabilityClaimsPart2": [
		414,
		135
	],
	"./UnderstandingLiabilityClaimsPart2.js": [
		414,
		135
	],
	"./UnderstandingLiabilityClaimsPart3": [
		415,
		11
	],
	"./UnderstandingLiabilityClaimsPart3.js": [
		415,
		11
	],
	"./UnderstandingLiabilityClaimsPart4": [
		416,
		12
	],
	"./UnderstandingLiabilityClaimsPart4.js": [
		416,
		12
	],
	"./UnderstandingLiabilityClaimsPart5": [
		417,
		13
	],
	"./UnderstandingLiabilityClaimsPart5.js": [
		417,
		13
	],
	"./UnderstandingSASRIAExtensions": [
		342,
		14
	],
	"./UnderstandingSASRIAExtensions.js": [
		342,
		14
	],
	"./ValidityOfClaims": [
		343,
		33
	],
	"./ValidityOfClaims.js": [
		343,
		33
	],
	"./ValidityOfClaimsPart2": [
		344,
		34
	],
	"./ValidityOfClaimsPart2.js": [
		344,
		34
	],
	"./WaterLeakageTips": [
		345,
		35
	],
	"./WaterLeakageTips.js": [
		345,
		35
	],
	"./WaterproofingAndWaterIngressPart1": [
		418,
		36
	],
	"./WaterproofingAndWaterIngressPart1.js": [
		418,
		36
	],
	"./WaterproofingAndWaterIngressPart2": [
		419,
		37
	],
	"./WaterproofingAndWaterIngressPart2.js": [
		419,
		37
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy": [
		346,
		38
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy.js": [
		346,
		38
	],
	"./WhatAreGeysersCoveredFor": [
		347,
		39
	],
	"./WhatAreGeysersCoveredFor.js": [
		347,
		39
	],
	"./WhatConstitutesAVoluntaryWorker": [
		348,
		40
	],
	"./WhatConstitutesAVoluntaryWorker.js": [
		348,
		40
	],
	"./WhatDamageRiskManagement": [
		349,
		41
	],
	"./WhatDamageRiskManagement.js": [
		349,
		41
	],
	"./WhatIsASpecificExclusion": [
		350,
		42
	],
	"./WhatIsASpecificExclusion.js": [
		350,
		42
	],
	"./WhatIsCoveredUnderExtraCover": [
		351,
		43
	],
	"./WhatIsCoveredUnderExtraCover.js": [
		351,
		43
	],
	"./WhatIsCoveredUnderTheLiabilitySection": [
		352,
		44
	],
	"./WhatIsCoveredUnderTheLiabilitySection.js": [
		352,
		44
	],
	"./WhatIsExtraCoverFollowingDamage": [
		353,
		45
	],
	"./WhatIsExtraCoverFollowingDamage.js": [
		353,
		45
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover": [
		354,
		46
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover.js": [
		354,
		46
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys": [
		355,
		47
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys.js": [
		355,
		47
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery": [
		356,
		48
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery.js": [
		356,
		48
	],
	"./WhenIsALossadjusterAppointed": [
		357,
		49
	],
	"./WhenIsALossadjusterAppointed.js": [
		357,
		49
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires": [
		358,
		136
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires.js": [
		358,
		136
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 256;
module.exports = webpackAsyncContext;